(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ebpak-festive-campaign"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',async function(event){const button=event.target.closest('[data-ebbf-code]');if(!button)return;const section=button.closest('.ebbf');const status=section.querySelector('[data-ebbf-status]');const code=button.dataset.ebbfCode;try{await navigator.clipboard.writeText(code);status.textContent=code+' '+status.dataset.copied;}catch(error){status.textContent=status.dataset.fallback+' '+code;}});
(function(){function tick(){document.querySelectorAll('[data-ebbf-end]').forEach(function(el){var end=Date.parse(el.dataset.ebbfEnd);if(isNaN(end))return;var ms=end-Date.now();if(ms<=0){el.hidden=true;return;}el.hidden=false;var m=Math.floor(ms/60000);el.querySelector('[data-ebbf-d]').textContent=Math.floor(m/1440);el.querySelector('[data-ebbf-h]').textContent=Math.floor(m%1440/60);el.querySelector('[data-ebbf-m]').textContent=m%60;});}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',tick);}else{tick();}setInterval(tick,30000);document.addEventListener('shopify:section:load',tick);})();

  } catch(e) { console.error(e); }
})();
})();
